import React from 'react'
import Topheader from '../Home/topHeader/Topheader'
import Middlebar from '../Home/middleBar/Middlebar'
import NavMenu from '../Home/navigationBar/NavMenu'
import Footer from '../Home/footer/Footer'
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"

const images = [
  "Sp2.jpg",
  "Sp3.jpg",
  "Sp4.jpg",
  "Sp3.jpg",
  "Sp4.jpg",
  "Sp2.jpg",
  "Sp2.jpg",
  "Sp3.jpg",
  "Sp4.jpg",
  "Sp3.jpg",
  "Sp4.jpg",
  "Sp2.jpg",
 
    "Sp5.jpg",
    "Sp6.jpg",
]

const Sports = () => {
  return (
    <>
    <Topheader/>
    <Middlebar/>
    <NavMenu/>
      <div className="p-4 mb-5">
        <div className="head mt-4">
          <h1 className="text-6xl flex justify-center font-monserrat text-maroon">Sports Day</h1>
        </div>
        <div className='p-20 -mt-10'>

        <ResponsiveMasonry
                columnsCountBreakPoints={{350: 1, 750: 2, 1000: 3}}
                >
                <Masonry gutter='15px'>
                    {images.map((image, i) => (
                      <img
                      key={i}
                      src={image}
                      // style={{width: "100%", display: "block"}}
                      className="w-1000 block rounded-lg"
                      alt=""
                      />
                      ))}
                </Masonry>
            </ResponsiveMasonry>
                      </div>
                </div> 
            <Footer/> 
    </>
  )
}

export default Sports
